import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { NutritionZincDiagramContent } from "./NutritionZincDiagram";
import { NutritionZincKeyContent } from "./NutritionZincKey";

const SvgNutritionZincDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1000, 1250)}
      viewBox={diagramOnly ? "0 176 1024 1000" : "0 0 1024 1250"}
    >
      <g id="nutrition-zinc-diagram+key" clipPath="url(#clip0_18284_196601)">
        <rect width={1024} height={diagramOnly ? 1000 : 1250} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <NutritionZincKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <NutritionZincDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18284_196601">
          <rect width={1024} height={1250} fill="white" />
        </clipPath>
        <clipPath id="clip1_18284_196601">
          <rect width={1024} height={1000} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgNutritionZincDiagramKey;
